import { SiGithub } from "@icons-pack/react-simple-icons";
import {
  BellIcon,
  BoxIcon,
  CalendarSyncIcon,
  CirclePlayIcon,
  GlobeIcon,
  LifeBuoyIcon,
  ExternalLinkIcon as LucideExternalLinkIcon,
  SearchIcon as LucideSearchIcon,
  SettingsIcon as LucideSettingsIcon,
  NetworkIcon,
  PlugIcon,
  RefreshCwIcon,
  Rows4Icon,
  SquareArrowRightEnterIcon,
  SquareTerminalIcon,
  UsersRoundIcon,
  PresentationIcon,
} from "lucide-react";

import { cn } from "cn";

export const DataSourceIcon = BoxIcon;
export const ReverseEtlIcon = CirclePlayIcon;
export const EditorIcon = SquareTerminalIcon;
export const SettingsIcon = LucideSettingsIcon;
export const AlertsIcon = BellIcon;
export const HelpIcon = LifeBuoyIcon;
export const SearchIcon = LucideSearchIcon;

export const WebhookIcon = GlobeIcon;
export const DestinationIcon = SquareArrowRightEnterIcon;
export const DashboardIcon = PresentationIcon;
export const OrchestrationIcon = (
  props: React.ComponentProps<typeof NetworkIcon>,
) => <NetworkIcon {...props} className={cn(props.className, "-rotate-90")} />;
export const LocalScheduleIcon = CalendarSyncIcon;

export const ConnectorsIcon = PlugIcon;
export const ActiveRowsIcon = Rows4Icon;
export const UsersIcon = UsersRoundIcon;
export const SyncFrequencyIcon = RefreshCwIcon;

export const ExternalLinkIcon = LucideExternalLinkIcon;

export const GitHubIcon = SiGithub;
